import axios from 'axios';

export async function getEventGraph(eventId) {
	return await axios.get(`${process.env.API_URL}/graph/${eventId}/nlb`, {
		withCredentials: true,
	});
}

export async function getEventSponsors(eventId) {
	return await axios.get(`${process.env.API_URL}/sponsors/${eventId}`, {
		withCredentials: true,
	});
}
